export default __webpack_public_path__ + "static/1175-5eabd93ddf374741b3e8969f76f9ef9b.gif";